import AddPositioningDeviceTypeModal from './add-positioning-device-type-modal.vue'
export default AddPositioningDeviceTypeModal
